import { put, call, select, takeLatest } from "redux-saga/effects";
import { format } from "date-fns";
import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";
import { nodes } from "@constants/filters";
import { filterActionTypes, filterSelectors } from "@store/ducks";

export const actionTypes = {
  fetchData: "modeWiseIncentives/INITIATE_FETCH_DATA",
  fetchDataFailed: "modeWiseIncentives/FETCH_DATA_FAILED",
  fetchDataFulfilled: "modeWiseIncentives/FETCH_DATA_FULFILLED",
};

const initialState = {
  fetching: false,
  fetched: false,
  data: {},
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchData: {
      return { ...state, fetching: true };
    }
    case actionTypes.fetchDataFailed: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errMsg: action.payload,
      };
    }
    case actionTypes.fetchDataFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
        errMsg: null,
      };
    }
    default: {
      return state;
    }
  }
};

export const selectors = {
  getRows: (state) =>
    (state.partnerApp.modeWiseIncentives.data && state.partnerApp.modeWiseIncentives.data.incentives) || [],
  getTotalRows: (state) =>
    state.partnerApp.modeWiseIncentives.data && state.partnerApp.modeWiseIncentives.data.total_count,
  isFetching: (state) => state.partnerApp.modeWiseIncentives.fetching,
  isFetched: (state) => state.partnerApp.modeWiseIncentives.fetched,
};

export const actions = {
  fetchData: (data) => ({
    type: actionTypes.fetchData,
    payload: data,
  }),
  fetchDataFailed: (data) => ({
    type: actionTypes.fetchDataFailed,
    payload: data,
  }),
  fetchDataFulfilled: (data) => ({
    type: actionTypes.fetchDataFulfilled,
    payload: data,
  }),
};

function* fetchDataWorker() {
  const state = yield select();
  const {
    dateFrom,
    dateTo,
    pageOffset,
    pageSize,
    order,
    orderBy,
    groupBy,
  } = filterSelectors.getFilters(state, nodes.modeWiseIncentives);
  try {
    const response = yield call(
      [axios, 'get'],
      API_ENDPOINTS.INCENTIVES.MODE_WISE_LIST({
        dateFrom: `${format(dateFrom, "yyyy-MM-dd")}`,
        dateTo: `${format(dateTo, "yyyy-MM-dd")}`,
        groupBy,
        orderBy,
        order,
        pageOffset,
        pageSize,
      })
    );
    if (response.status == 200) {
      yield put(actions.fetchDataFulfilled(response.data.result));
    }
  } catch (err) {
    const errMsg = (err && err.message) || "Something went wrong";
    yield put(actions.fetchDataFailed(errMsg));
  }
}

export function* saga() {
  yield takeLatest(actionTypes.fetchData, fetchDataWorker);
  yield takeLatest(filterActionTypes.updateModeWiseIncentiveFilter, fetchDataWorker);
}
